import {
  getAddressInfo,
  getDefaultAddress
} from '@/api/address'

/**
 * 获取默认地址
 */
export const getDefaultAddr = async () => {
  const result = await getDefaultAddress()
  const addressInfo = result.data.data.addressInfo

  if (Object.keys(addressInfo).length !== 0) {
    return {
      status: true,
      addressInfo
    }
  }

  return {
    status: false,
    addressInfo: {}
  }
}

/**
 * 根据 ID 获取地址详情
 */
export const getAddress = async addressId => {
  const result = await getAddressInfo({
    address_id: addressId
  })
  const data = result.data.data

  return {
    status: data.status,
    addressInfo: data.addressInfo
  }
}

/**
 * 获取当前地址（优先使用选中地址，否则使用默认地址）
 *
 * 选中地址可能已在别处被删除或改动, 所以必须过一次服务端校验:
 * 校验不通过就清掉本地缓存, 回落到默认地址, 避免 state 一直挂着死 id.
 *
 * @param {Object} [options]
 * @param {boolean} [options.force=false] 为 true 时跳过「已校验」判断, 强制重新拉取
 */
export const getCurrentAddress = async (
  { state, commit },
  { force = false } = {}
) => {
  const {
    addressId,
    validatedAddressId,
    addressInfo
  } = state

  // 同一个 id 已校验过且详情在手, 直接复用, 不再打接口
  if (
    !force &&
    addressId &&
    addressId === validatedAddressId &&
    addressInfo?.address_id
  ) {
    return { status: true, addressInfo }
  }

  let address = { status: false, addressInfo: {} }

  if (addressId) {
    // 地址被删时接口可能直接报错, 与校验不通过同样处理
    address = await getAddress(addressId).catch(error => {
      console.error('校验选中地址失败', error)
      return { status: false, addressInfo: {} }
    })

    if (!address.status) {
      commit('CLEAN_ADDRESSID')
    }
  }

  if (!address.status) {
    address = await getDefaultAddr()
  }

  if (address.status) {
    commit('setAddressInfo', address.addressInfo)
    commit(
      'SET_VALIDATED_ADDRESSID',
      address.addressInfo.address_id
    )
  }

  return address
}
